import { Skeleton } from "@/components/ui/skeleton";

export function LoadingSkeleton() {
  return (
    <div className="flex h-screen bg-background">
      <aside className="hidden md:flex w-60 shrink-0 flex-col border-r bg-sidebar">
        <div className="h-14 flex items-center gap-2 px-5 border-b">
          <Skeleton className="w-7 h-7 rounded-lg" />
          <Skeleton className="h-4 w-28" />
        </div>
        <div className="flex-1 px-3 py-3 space-y-5">
          {[1, 2, 3, 4].map((s) => (
            <div key={s}>
              <Skeleton className="h-3 w-20 mb-2" />
              <div className="space-y-2">
                <Skeleton className="h-7 w-full" />
                <Skeleton className="h-7 w-full" />
              </div>
            </div>
          ))}
        </div>
      </aside>
      <div className="flex flex-1 flex-col">
        <header className="h-14 border-b flex items-center px-4 gap-3">
          <Skeleton className="h-9 w-72" />
          <div className="flex-1" />
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-9 w-9 rounded-full" />
        </header>
        <div className="flex-1 p-8 space-y-4">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-32 w-full max-w-3xl" />
          <Skeleton className="h-32 w-full max-w-3xl" />
        </div>
      </div>
    </div>
  );
}
